import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { calcResize } from 'components/Layout/styles';

export const SContainer = styled.div.attrs({
  className: 'container ',
})`
  position: relative;
`;

export const STitle = styled.div`
  color: ${props => props.theme.colors.accent};
  text-align: center;
  font-size: ${calcResize(45, 60)};
`;

export const SSection = styled.div`
  background-color: ${props => props.theme.colors.main};
  padding: 100px 0;
  overflow: hidden;
  position: relative;

  @media only screen and (max-width: 992px) {
    padding: 50px 0 25px;
  }
`;

export const SDescription = styled.div`
  color: #edf0f6;
  text-align: center;
  font-size: ${calcResize(15, 20)};
`;

export const SRow = styled.div.attrs({ className: 'mx-5 row' })`
  &.header {
    justify-content: center;
    margin: 0 auto 50px;

    @media only screen and (max-width: 992px) {
      margin: 0 auto 20px;
    }
  }

  &.body {
    margin: 0 auto !important;
  }
`;
